var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22453 6.85714L7.27893 10.5368C7.64776 10.8715 7.64776 11.4142 7.27893 11.7489C6.9101 12.0837 6.31211 12.0837 5.94329 11.7489L0.276619 6.60609C-0.0922103 6.27136 -0.0922102 5.72864 0.27662 5.39391L5.94329 0.251053C6.31212 -0.083682 6.9101 -0.083682 7.27893 0.251053C7.64776 0.585788 7.64776 1.1285 7.27893 1.46324L3.22453 5.14286L16.0556 5.14286C16.5772 5.14286 17 5.52661 17 6C17 6.47339 16.5772 6.85714 16.0556 6.85714L3.22453 6.85714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftOne);
export default __webpack_public_path__ + "static/media/arrow-left-one.aa5aad184b4c1e80dd6c5b0d947f8065.svg";
export { ForwardRef as ReactComponent };